import { Trans } from 'react-i18next'

import { Meter, projectStatusColor, Status } from '@makyoapp/makyo-ui'

import { useDateFmt } from '@/hooks/useDateFmt'

interface MeterProps {
  value: number
  max: number
  color?: string
  singleColor?: boolean
  unit?: string
}

interface MeterVars {
  usage: MeterProps
  records: MeterProps
  screens: MeterProps
}

export interface ProjectInfoProps {
  status: string
  plan: string
  href?: string
  team: React.ReactNode
  meters: MeterVars
  created: Date
  updated: Date
  org: React.ReactNode
  creator: React.ReactNode
}

function ProjectInfo(props: ProjectInfoProps) {
  const items: Array<keyof MeterVars> = ['usage', 'records', 'screens']
  const flexCls = 'flex items-center'
  const labelCls = 'basis-1/3 shrink-0'
  const dateFmtDefault = useDateFmt()
  return (
    <div className='flex flex-col gap-6'>
      <div className={flexCls}>
        <span className={labelCls}>
          <Trans>Status</Trans>
        </span>
        <Status className='uppercase' dotColor={projectStatusColor(props.status)}>
          {props.status}
        </Status>
      </div>
      {/* {items.map((item) => {
        const m = props.meters[item]
        return (
          <div key={item} className={flexCls}>
            <span className={labelCls}>
              <Trans>{item}</Trans>
            </span>
            <div className='flex justify-self-end items-center gap-2 basis-2/3'>
              <span className='w-[80px]'>
                <Meter value={m.value} max={m.max} colors={{ normal: m.color }} singleColor={m.singleColor} />
              </span>
              <span className='whitespace-nowrap'>
                {m.value} /{' '}
                <strong>
                  {m.max} {m.unit}
                </strong>
              </span>
            </div>
          </div>
        )
      })} */}
      <div className={flexCls}>
        <span className={labelCls}>
          <Trans>Organization</Trans>
        </span>
        {props.org}
      </div>
      <div className={flexCls}>
        <span className={labelCls}>
          <Trans>Team</Trans>
        </span>
        {props.team}
      </div>
      <div className={flexCls}>
        <span className={labelCls}>
          <Trans>Creator</Trans>
        </span>
        {props.creator}
      </div>
      <div className={flexCls}>
        <span className={labelCls}>
          <Trans>Created</Trans>
        </span>
        {dateFmtDefault(props.created)}
      </div>
      <div className={flexCls}>
        <span className={labelCls}>
          <Trans>Updated</Trans>
        </span>
        {dateFmtDefault(props.updated)}
      </div>
    </div>
  )
}

export default ProjectInfo
